import { selectCurrentAttachments } from './attachments.selector';
import { selectShare } from './share.selector';
import { createSelector } from '@ngrx/store';

export const selectCurrentNote = createSelector(
  selectShare,
  selectCurrentAttachments,
  (share: any, attachments) => {
    let note;
    const {share: instance, result:{entities}} = share;
    if (instance && entities && entities.notes) {
      const sharedNote = entities.notes[instance.note];
      if (!sharedNote) {
        return undefined;
      }

      note = Object.assign({}, note, sharedNote);
    } else {
      return undefined;
    }

    let isVideoNote = false;
    let isImageNote = false;
    let videoNote;
    let imageNote;
    if (attachments && attachments.length) {
      if ((note.role === 'screencast' || note.role === 'video')
        && attachments[0].type === 'video' && attachments[0].inList
      ) {
        isVideoNote = true;
        videoNote = attachments[0];
      }

      if (note.role === 'screenshot' && attachments[0].type === 'image' && attachments[0].inList) {
        isImageNote = true;
        imageNote = attachments[0];
      }
    }
    note = Object.assign({}, note, {
      isVideoNote,
      videoNote,
      isImageNote,
      imageNote
    });
    return note;
  }
);
